import { query, ua } from '@kk/utils';
import globalData from '@kk-activity-factory/global-data';
import { globalInstance } from './globalInstance';

function checkSourcePlatform() {
    if (ua.wechatmini) {
        return 'wechat';
    }
    if (ua.qqmini) {
        return 'qq';
    }
    if (ua.baidumini) {
        return 'baidu';
    }
    if (ua.quarkmini) {
        return 'quark';
    }
    if (ua.alipaymini) {
        return 'alipay';
    }
    if (ua.ucmini) {
        return 'uc';
    }
    if (ua.kuaishoumini) {
        return 'kuaishou';
    }
    if (ua.harmonymini) {
        return 'harmony';
    }
    return '未知';
}

let SourcePlatform;
if (window.isKuaikanMini) {
    SourcePlatform = checkSourcePlatform();
}

/**
 * @param {string | null } event 事件名
 * @param {any} param 参数
 * @return {any} 不传event时候会返回对象
 */
export function kksaTrack(event, param = {}) {
    if (globalData.innerPreview) {
        return;
    }
    const store = globalInstance.getRootStore();
    const data = {
        Visit_Source: globalData.visitSource,
        PageID: query.get('id'),
        LiveActivityID: `${store.state.pageData.activityId}`,
        ActivityMark: `${store.state.pageData.activityMark}`,
    };
    if (window.isKuaikanMini) {
        Object.assign(data, {
            SourcePlatform: `${SourcePlatform}`,
            mini_program_version: `${ua.miniversion || '未知'}`,
        });
    } else if (globalData.isKuaikan) {
        Object.assign(data, {
            $app_version: window.globalAppVersionName,
            xdevice: window.globalDeviceId,
        });
    } else {
        Object.assign(data, {
            $app_version: window.globalAppVersionName,
        });
    }
    const saData = Object.assign(data, param);
    if (saData.ModeID) {
        saData['Category'] = store.getters.categoryMap.get(saData.ModeID);
    }
    if (!event) {
        return saData;
    }
    kksa.track(event, saData);
    if (process.env.VUE_APP_HOST_ENV === 'development') {
        console.info(event, saData);
    }
}
